// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"39f70bb5","667":"c378ad06","977":"9b20c645"}[chunkId] + ".chunk.js";
};